// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3AR46","modalForm":"UpgradeEpcsModal_modalForm__3CG3o","modalFooter":"UpgradeEpcsModal_modalFooter__18XFO"};